var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIoLostComsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81 67.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.9,0H5.1C2.3,0,0,2.3,0,5.1v44.9C0,52.7,2.3,55,5.1,55h32.4v6.4H21c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2 H60c1.8,0,3.2-1.4,3.2-3.2s-1.4-3.2-3.2-3.2H43.5V55h32.4c2.8,0,5.1-2.3,5.1-5.1V5.1C81,2.3,78.7,0,75.9,0z M53.6,34.8 c1.6,1.6,1.5,4.1-0.1,5.7c-1.6,1.6-4.1,1.6-5.7,0.1l-7.4-7.4L33,40.6c-1.6,1.6-4.1,1.5-5.7-0.1c-1.6-1.6-1.6-4.1-0.1-5.7l7.4-7.4 L27.2,20c-1.6-1.6-1.5-4.1,0.1-5.7c1.6-1.6,4.1-1.6,5.7-0.1l7.4,7.4l7.4-7.4c1.6-1.6,4.1-1.5,5.7,0.1c1.6,1.6,1.6,4.1,0.1,5.7 l-7.4,7.4L53.6,34.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIoLostComsIcon);
export default __webpack_public_path__ + "static/media/io-lost-coms-icon.b58a9de159fc756b254855572086e7fb.svg";
export { ForwardRef as ReactComponent };